import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon", "answer"]

  toggle(event) {
    const button = event.currentTarget
    const answer = button.parentElement.nextElementSibling
    const icon = button.querySelector("svg")

    answer.classList.toggle("hidden")
    icon.classList.toggle("hidden")
    const otherIcon = icon.nextElementSibling || icon.previousElementSibling
    if (otherIcon) otherIcon.classList.toggle("hidden")
  }
}
